import { IsNumber, IsOptional } from 'class-validator';

export class EmployeeCheckRequestDto {
    number: string;

    @IsNumber()
    @IsOptional()
    merchantId?: number;
  }
  